import request from '@/config';
import { useAppStoreWithOut } from '@/store/app';

enum Apis {
	PayplanConfig = `/api/contractdraft/getpayplanconfig`,
	CipherAmount = `/api/contractdraft/cipherpayplanamount`,
	CipherScalc = `/api/contractdraft/cipherpayplanscalc`,
	RelateContract = `/api/contractdraft/getcontractexceptdraftlist`
}

/* 计算付款计划中可设置的金额/比例 */
export const GetPayplanConfigApi = (ctAmount: number, planList: any[]): Promise<IResponse> =>
	request.post({
		url: Apis.PayplanConfig,
		data: { contract_amount: ctAmount, plan_list: planList },
	});

/* 通过金额计算比例 */
export const CipherAmountApi = (ctAmount: number, amount: number): Promise<IResponse> =>
	request.post({
		url: Apis.CipherAmount,
		data: { amount: amount, contract_amount: ctAmount },
	});

/* 通过比例计算金额 */
export const CipherScalcApi = (amount: number, scalc: number, maxScalc?: number): Promise<IResponse> =>
	request.post({
		url: Apis.CipherScalc,
		data: { amount: amount, scalc: scalc, max_scalc: maxScalc },
	});

/* 获取可关联的合同 */
export const RelateContractApi = (): Promise<IResponse> =>
	request.post({
		url: Apis.RelateContract
	});
